// Official Clara brand logo (real artwork). Two variants:
//  - "maroon": deep-maroon wordmark for light backgrounds
//  - "cream":  cream wordmark for dark backgrounds
const SRC = {
  maroon: "/clara-logo-maroon.webp",
  cream: "/clara-logo-cream.webp",
};

export const ClaraLogo = ({ variant = "maroon", className = "" }) => (
  <img
    src={SRC[variant] || SRC.maroon}
    alt="Clara Cocoa Powder"
    className={`w-auto select-none ${className}`}
    draggable="false"
    data-testid="clara-logo"
  />
);

export default ClaraLogo;
